module.exports = {
  MPA_TRANSACTIONS_EDIT_REQUEST: 'MPA_TRANSACTIONS_EDIT_REQUEST',
  MPA_TRANSACTIONS_EDIT_SUCCESS: 'MPA_TRANSACTIONS_EDIT_SUCCESS',
  MPA_TRANSACTIONS_EDIT_FAILURE: 'MPA_TRANSACTIONS_EDIT_FAILURE',
};
